import React from 'react';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
// import classes from './Toastr.module.css';

const Toastr = (props) => {
    return (
      <Snackbar anchorOrigin={{ vertical:"bottom", horizontal:"left" }}
        autoHideDuration={2000} open={props.open} onClose={props.closeHandler}>
        <Alert severity={props.severity} color={props.color} >
          {props.content}
        </Alert>
      </Snackbar>
    );
  }

  export default Toastr;